<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <Sessionmgmt></Sessionmgmt>
      </v-col>
      <v-col cols="12" md="7">
        <v-container>
          <v-card tile>
            <v-card-text>
              <Rendertable></Rendertable>
            </v-card-text>
          </v-card>
        </v-container>
      </v-col>
      <v-col cols="12" md="5">
        <v-container>
          <v-card tile>
            <v-card-text>
              <Rendercal></Rendercal>
            </v-card-text>
          </v-card>
        </v-container>
        <Scrape730 v-if="placeid == 730"></Scrape730>
        <DownloadDatabaseDump v-if="placeid"></DownloadDatabaseDump>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Rendertable from '@/components/Rendertable.vue'
import Rendercal from '@/components/Rendercal.vue'
import Sessionmgmt from '@/components/Sessionmgmt.vue'
import Scrape730 from '@/components/Scrape730.vue'
import DownloadDatabaseDump from '@/components/DownloadDatabaseDump.vue'

export default {
  name: 'home',
  components: {
    Rendertable,
    Rendercal,
    Sessionmgmt,
    Scrape730,
    DownloadDatabaseDump,
  },
  computed: {
    placeid() { return this.$store.getters.placeid }
  }
}
</script>
